@if (getDisplayViewType(); as viewType) {
    <div class="PGFormField PGFormField--Type{{viewType.charAt(0).toUpperCase() + viewType.slice(1)}}" [ngClass]="{ 'PGFormField--NoLabel': noLabel }">
        <div class="form-group {{display && display.inlineLabel ? 'PGFormField--DisplayInlineLabel' : ''}}">
            <label [for]="fieldId" [style.display]="fieldData.hidden ? 'none' : null" class="{{viewType == 'info' ? 'alert alert-' + (fieldData.infoType || 'info') : ''}}">
                @if (fieldData.tooltip != null) {
                    @if (viewType != 'info') {
                        <small class="form-text text-muted" [innerHTML]="fieldData.tooltip | locTranslate"></small>
                    }
                    @if (viewType == 'info') {
                        <span class="form-text" [innerHTML]="fieldData.tooltip | locTranslate"></span>
                    }
                }
                @if (viewType == 'select') {
                    <span>
                        <app-pg-select [fieldId]="fieldId" [ariaLabel]="fieldData.label | locTranslate | stripHTML" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required" [useKeys]="fieldData.useKeys"
                            [resource]="getFieldResource()" [resourceMode]="fieldData.resourceMode" [resourceSemantic]="fieldData.resourceSemantic" [options]="getFieldOptions()" [optionsFilter]="optionsFilter" [optionsValue]="fieldData.optionsValue" 
                            [multi]="fieldData.multi" [searchMin]="fieldData.searchMin" [display]="display?.oneLine ? 'oneLine' : display?.multiLine ? 'multiLine' : null" [noSelectionText]="display?.noSelectionText"
                            [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()">
                        </app-pg-select>
                    </span>
                }
                @if (viewType == 'timetable-periods') {
                    <span>
                        <app-pg-timetable-editor [fieldId]="fieldId" timetableMode="periods" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required" [multi]="fieldData.multi" [timezone]="fieldData.timezone"
                            [multi]="fieldData.multi"[ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()">
                        </app-pg-timetable-editor>
                    </span>
                }
                @if (viewType == 'timetable-openings') {
                    <span>
                        <app-pg-timetable-editor [fieldId]="fieldId" timetableMode="openings" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required" [multi]="fieldData.multi" [timezone]="fieldData.timezone"
                            [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()">
                        </app-pg-timetable-editor>
                    </span>
                }
                @if (viewType == 'timetable-slots') {
                    <span>
                        <app-pg-timetable-editor [fieldId]="fieldId" timetableMode="slots" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required" [multi]="fieldData.multi" [timezone]="fieldData.timezone"
                            [availableLanguages]="getAvailableLanguages()" [selectedLanguage]="getSelectedLanguage()" [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()">
                        </app-pg-timetable-editor>
                    </span>
                }
                @if (viewType == 'timetable-dates') {
                    <span>
                        <app-pg-timetable-editor [fieldId]="fieldId" timetableMode="dates" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required" [multi]="fieldData.multi" [timezone]="fieldData.timezone"
                            [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()">
                        </app-pg-timetable-editor>
                    </span>
                }
                @if (viewType == 'timetable-departures') {
                    <span>
                        <app-pg-timetable-editor [fieldId]="fieldId" timetableMode="departures" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required" [multi]="fieldData.multi" [timezone]="fieldData.timezone"
                            [multi]="fieldData.multi"[ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()">
                        </app-pg-timetable-editor>
                    </span>
                }
                @if (viewType == 'timetable-days') {
                    <span>
                        <app-pg-timetable-editor [fieldId]="fieldId" timetableMode="days" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required" [multi]="fieldData.multi" [timezone]="fieldData.timezone"
                            [multi]="fieldData.multi"[ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()">
                        </app-pg-timetable-editor>
                    </span>
                }
                @if (viewType == 'timetable-event') {
                    <span>
                        <app-pg-timetable-editor [fieldId]="fieldId" timetableMode="event" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required" [multi]="fieldData.multi" [timezone]="fieldData.timezone"
                            [multi]="fieldData.multi"[ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()">
                        </app-pg-timetable-editor>
                    </span>
                }
                @if (viewType == 'tickets-experience' || viewType == 'tickets-host') {
                    <span>
                        <app-pg-tickets-editor [fieldId]="fieldId" [ticketsType]="viewType.split('-')[1]" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required" [availableLanguages]="getAvailableLanguages()" [selectedLanguage]="getSelectedLanguage()" [currency]="getCurrency()"
                            [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()">
                        </app-pg-tickets-editor>
                    </span>
                }
                @if (viewType == 'survey') {
                    <span>
                        <app-pg-survey-editor [fieldId]="fieldId" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required" [availableLanguages]="getAvailableLanguages()" [selectedLanguage]="getSelectedLanguage()"
                            [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()">
                        </app-pg-survey-editor>
                    </span>
                }
                @if (viewType == 'rating') {
                    <span>
                        <app-pg-rating [fieldId]="fieldId" [ariaLabel]="fieldData.label | locTranslate | stripHTML" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required"
                            [icon]="fieldData.icon"
                            [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()">
                        </app-pg-rating>
                    </span>
                }
                @if (viewType == 'html') {
                    <span>
                        <app-pg-html-editor [fieldId]="fieldId" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required" [allowAdvanced]="isSuperAdmin()"
                            [htmlMode]="fieldData.htmlMode"
                            [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()">
                        </app-pg-html-editor>
                    </span>
                }
                @if (viewType == 'json') {
                    <span>
                        <app-pg-json-editor [fieldId]="fieldId" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required"
                            [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()" [jsonType]="fieldData.jsonType">
                        </app-pg-json-editor>
                    </span>
                }
                @if (viewType == 'object') {
                    <span>
                        <pre [id]="fieldId">{{getFieldValue()|json}}</pre>
                    </span>
                }
                @if (viewType == 'text' || viewType == 'blob') {
                    <span>
                        <textarea [id]="fieldId" class="form-control" [readonly]="fieldData.readonly || disabled" [disabled]="fieldData.readonly || disabled"
                            [required]="fieldData.required" [maxLength]="fieldData.maxLength" [placeholder]="(fieldData.placeholder || '') | locTranslate"
                            [attr.aria-invalid]="isFieldInvalid() || null" [attr.aria-describedby]="getAriaDescribedBy()"
                        [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()"></textarea>
                    </span>
                }
                @if (viewType == 'string') {
                    <span [ngClass]="{ 'input-group': fieldData.icon || fieldData.text != null }">
                        @if (fieldData) {
                            <!-- non so se abbia senso gestirlo con le configurazioni -->
                            @if (fieldData.name == 'tags') {
                                <app-pg-tags [fieldId]="fieldId" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required"
                                    [placeholder]="(fieldData.placeholder || '') | locTranslate"
                                [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()"></app-pg-tags>
                            }
                            @if (fieldData.name != 'tags') {
                                <input [id]="fieldId" class="form-control" type="text"
                                    [readonly]="fieldData.readonly || disabled" [disabled]="fieldData.readonly || disabled" [required]="fieldData.required"
                                    [maxLength]="fieldData.maxLength" [placeholder]="(fieldData.placeholder || '') | locTranslate"
                                    [attr.aria-invalid]="isFieldInvalid() || null" [attr.aria-describedby]="getAriaDescribedBy()"
                                    [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()"/>
                            }
                            @if (fieldData.icon || fieldData.text != null) {
                                <span class="input-group-text">
                                    @if (fieldData.icon) {
                                        <i class="{{fieldData.icon}}"></i>
                                    }
                                    @if (fieldData.text) {
                                        <span>{{fieldData.text}}</span>
                                    }
                                </span>
                            }
                        }
                    </span>
                }
                @if (viewType == 'email') {
                    <span>
                        <app-pg-email [fieldId]="fieldId" [ariaInvalid]="isFieldInvalid()" [ariaDescribedBy]="getAriaDescribedBy()" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required"
                        [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()"></app-pg-email>
                    </span>
                }
                @if (viewType == 'phone' || viewType == 'phone-international') {
                    <span>
                        <app-pg-phone [fieldId]="fieldId" [ariaInvalid]="isFieldInvalid()" [ariaDescribedBy]="getAriaDescribedBy()" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required" [international]="viewType == 'phone-international'"
                        [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()"></app-pg-phone>
                    </span>
                }
                @if (viewType == 'recipient') {
                    <span>
                        <app-pg-recipient [id]="fieldId" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required" [compositeValue]="true"
                        [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()"></app-pg-recipient>
                    </span>
                }
                @if (viewType == 'integer') {
                    <span [ngClass]="{ 'input-group': fieldData.icon }">
                        <input [id]="fieldId" class="form-control" [readonly]="fieldData.readonly || disabled" [disabled]="fieldData.readonly || disabled" [required]="fieldData.required" [min]="fieldData.min" [max]="fieldData.max" [attr.step]="1"
                            type="string" format="integer"
                            [attr.aria-invalid]="isFieldInvalid() || null" [attr.aria-describedby]="getAriaDescribedBy()"
                            [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()" (keyup)="handleNumericKeyup($event, true)"/>
                        @if (fieldData.icon) {
                            <span class="input-group-text">
                                <i class="{{fieldData.icon}}"></i>
                            </span>
                        }
                    </span>
                }
                @if (viewType == 'decimal' || viewType == 'float') {
                    <span [ngClass]="{ 'input-group': fieldData.icon }">
                        <input [id]="fieldId" class="form-control" [readonly]="fieldData.readonly || disabled" [disabled]="fieldData.readonly || disabled" [required]="fieldData.required" [min]="fieldData.min" [max]="fieldData.max" [step]="fieldData.step || 0.01"
                            type="string" format="decimal"
                            [attr.aria-invalid]="isFieldInvalid() || null" [attr.aria-describedby]="getAriaDescribedBy()"
                            [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()" (keyup)="handleNumericKeyup($event, false)"/>
                        @if (fieldData.icon) {
                            <span class="input-group-text">
                                <i class="{{fieldData.icon}}"></i>
                            </span>
                        }
                    </span>
                }
                @if (viewType == 'price') {
                    <span class="input-group">
                        <input [id]="fieldId" class="form-control" [readonly]="fieldData.readonly || disabled" [disabled]="fieldData.readonly || disabled" [required]="fieldData.required" [min]="fieldData.min" [max]="fieldData.max" step="0.01"
                            type="string" format="decimal"
                            [attr.aria-invalid]="isFieldInvalid() || null" [attr.aria-describedby]="getAriaDescribedBy()"
                            [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()"/>
                        <span class="input-group-text">
                            <b>{{getCurrencySymbol()}}</b>
                        </span>
                    </span>
                }
                @if (viewType == 'duration') {
                    <span>
                        <app-pg-duration [fieldId]="fieldId" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required" [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()"></app-pg-duration>
                    </span>
                }
                @if (viewType == 'social') {
                    <span>
                        <app-pg-social [fieldId]="fieldId" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required" [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()"></app-pg-social>
                    </span>
                }
                @if (viewType == 'password') {
                    <span>
                        <input [id]="fieldId" class="form-control" [readonly]="fieldData.readonly || disabled" [disabled]="fieldData.readonly || disabled" [required]="fieldData.required" [maxLength]="fieldData.maxLength"
                            type="password"
                            [attr.aria-invalid]="isFieldInvalid() || null" [attr.aria-describedby]="getAriaDescribedBy()"
                            [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()"/>
                    </span>
                }
                @if (viewType == 'slider') {
                    <span>
                        <app-pg-slider [fieldId]="fieldId" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required" [min]="fieldData.min" [max]="fieldData.max" [step]="fieldData.step" [scale]="fieldData.sliderScale"
                        [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()"></app-pg-slider>
                    </span>
                }
                @if (viewType == 'boolean') {
                    <span>
                        <app-pg-switch [fieldId]="fieldId" [ariaLabel]="fieldData.label | locTranslate | stripHTML" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required" [small]="display && display.inlineLabel"
                            [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()">
                        </app-pg-switch>
                    </span>
                }
                @if (viewType == 'date') {
                    <span class="PGFormField-Field--Small">
                        <app-pg-date-picker [fieldId]="fieldId" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required"
                            [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()">
                        </app-pg-date-picker>
                    </span>
                }
                @if (viewType == 'time') {
                    <span class="PGFormField-Field--Small">
                        <app-pg-time-picker [fieldId]="fieldId" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required"
                            [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()">
                        </app-pg-time-picker>
                    </span>
                }
                @if (viewType == 'datetime') {
                    <span>
                        <app-pg-datetime-picker [fieldId]="fieldId" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required"
                            [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()">
                        </app-pg-datetime-picker>
                    </span>
                }
                @if (viewType == 'location') {
                    <span>
                        <app-pg-location-picker [fieldId]="fieldId" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required" [placeholder]="fieldData.placeholder | locTranslate" [allowAdvanced]="isSuperAdmin()"
                            [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()" [slaves]="getFieldSlaves()" (setSlaves)="setFieldSlaves($event);">
                        </app-pg-location-picker>
                    </span>
                }
                @if (viewType == 'list') {
                    <span>
                        <app-pg-list-editor [fieldId]="fieldId" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required"
                            [resource]="getFieldResource()" [options]="getFieldOptions()" [order]="fieldData.order"
                            [searchMin]="fieldData.searchMin" [display]="display?.oneLine ? 'oneLine' : display?.multiLine ? 'multiLine' : null" [noSelectionText]="display?.noSelectionText"
                            [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()">
                        </app-pg-list-editor>
                    </span>
                }
                @if (viewType == 'file') {
                    <span>
                        <app-pg-file-picker [fieldId]="fieldId" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required" [multi]="fieldData.multi" [fileType]="fieldData.fileType" [fileOptions]="fieldData.fileOptions"
                            [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()" [groupId]="groupId" [realmId]="realmId" [directoryId]="fieldData.fileDirectory">
                        </app-pg-file-picker>
                    </span>
                }
                @if (viewType == 'split') {
                    <span>
                        <div class="border-bottom mb-2"></div>
                    </span>
                }
                @if (viewType == 'embed') {
                    <span>
                        <app-pg-embed-editor [fieldId]="fieldId" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required" [multi]="fieldData.multi"
                            [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()">
                        </app-pg-embed-editor>
                    </span>
                }
                @if (viewType == 'color') {
                    <span>
                        <app-pg-color-picker [fieldId]="fieldId" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required" [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()"></app-pg-color-picker>
                    </span>
                }
                @if (viewType == 'attachment') {
                    <span>
                        <app-pg-attachment-editor [fieldId]="fieldId" [readonly]="fieldData.readonly || disabled" [required]="fieldData.required" [multi]="fieldData.multi" [fileType]="fieldData.fileType" [fileOptions]="fieldData.fileOptions"
                            [ngModel]="getFieldValue()" (ngModelChange)="setFieldValue($event); emitChange()" [groupId]="groupId" [realmId]="realmId" [directoryId]="fieldData.fileDirectory">
                        </app-pg-attachment-editor>
                    </span>
                }
                <span class="PGFormField-Heading {{ hasBigHeading() ? 'PGFormField-Heading--Big' : '' }}">
                    @if (fieldData.label != null) {
                        @if (viewType == 'info') {
                            <h5 class="m-0">
                                <i class="fa-regular fa-info-circle me-2"></i>
                                <span [innerHTML]="fieldData.label | locTranslate"></span>
                            </h5>
                        }
                        @if (viewType != 'info') {
                            <b [innerHTML]="fieldData.label | locTranslate"></b>
                        }
                    }
                    <span class="PGFormField-Status text-muted">
                        @if (fieldData.required) {
                            <span class="PGFormField-Status-Required PGTooltip {{validationIssues != null && validationIssues.required != null ? 'text-danger' : ''}}"
                                [attr.aria-hidden]="true">
                                <i class="fa-regular fa-asterisk fa-sm" aria-hidden="true"></i>
                                @if (fieldData.multi) {
                                    <div class="PGTooltip-Content">{{ 'pg-form.issue-required-multi' | locTranslate }}</div>
                                }
                                @if (!fieldData.multi) {
                                    <div class="PGTooltip-Content">{{ 'pg-form.issue-required' | locTranslate }}</div>
                                }
                            </span>
                        }
                        <span class="PGFormField-Status-Other">
                            @if (fieldData.maxLength != null || fieldData.warnLength != null) {
                                <span [ngClass]="{
                                    'text-danger': validationIssues != null && validationIssues.maxLength != null,
                                    'text-warning': warningIssues != null && warningIssues.warnLength != null,
                                    'PGTooltip': warningIssues != null && warningIssues.warnLength != null && fieldData.warnMessage }"
                                    [title]="getFieldValueLengthReal()">
                                    {{getFieldValueLength()}}/{{fieldData.maxLength}}
                                    @if (warningIssues != null && warningIssues.warnLength != null && fieldData.warnMessage) {
                                        <div class="PGTooltip-Content">
                                            {{fieldData.warnMessage}}
                                        </div>
                                    }
                                </span>
                            }
                            @if (fieldData.warnIf != null && warningIssues != null && warningIssues.warnIf != null) {
                                <span class="PGTooltip">
                                    <i class="text-warning fa fa-exclamation-triangle"></i>
                                    @if (warningIssues != null && warningIssues.warnIf != null) {
                                        <div class="PGTooltip-Content">
                                            {{warningIssues.warnIf}}
                                        </div>
                                    }
                                </span>
                            }
                            @if (fieldData.min != null && fieldData.max != null) {
                                <span class="{{validationIssues != null && (validationIssues.min != null || validationIssues.max != null) ? 'text-danger' : ''}}">
                                    <b>MIN {{formatValue(fieldData.min)}} MAX {{formatValue(fieldData.max)}}</b>
                                </span>
                            }
                            @if (fieldData.min != null && fieldData.max == null) {
                                <span class="{{validationIssues != null && validationIssues.min != null ? 'text-danger' : ''}}">
                                    <b>MIN {{formatValue(fieldData.min)}}</b>
                                </span>
                            }
                            @if (fieldData.max != null && fieldData.min == null) {
                                <span class="{{validationIssues != null && validationIssues.max != null ? 'text-danger' : ''}}">
                                    <b>MAX {{formatValue(fieldData.max)}}</b>
                                </span>
                            }
                            @if (fieldData.constraints != null) {
                                <span class="PGTooltip {{validationIssues != null && validationIssues.constraints != null ? 'text-danger' : ''}}">
                                    <i class="fa-regular fa-link"></i>
                                    <div class="PGTooltip-Content">
                                        @for (constraint of fieldData.constraints; track constraint) {
                                            <div>{{formatConstraint(constraint)}}</div>
                                        }
                                    </div>
                                </span>
                            }
                        </span>
                    </span>
                    <span class="PGFormField-Actions">
                        @if (display != null && display.info != null) {
                            <span class="PGFormField-Actions-Info PGTooltip">
                                <i class="fa-regular fa-info-circle text-muted" aria-hidden="true"></i>
                                <span class="PGTooltip-Content" [innerHTML]="display.info"></span>
                            </span>
                        }
                        @if (fieldData.fieldActions != null) {
                            @for (action of fieldData.fieldActions; track action) {
                                <button type="button" class="btn btn-sm {{action.class || 'btn-white'}}" [attr.aria-label]="action.tooltip || (action.label | locTranslate) || null" [title]="action.tooltip || ''" (click)="action.run(fieldData)" [disabled]="fieldData.readonly || disabled">
                                    @if (action.icon) {
                                        <i class="{{action.icon}}" aria-hidden="true"></i>
                                    }
                                    @if (action.label != null) {
                                        <span>{{action.label | locTranslate}}</span>
                                    }
                                </button>
                            }
                        }
                        @if (fieldData.locale) {
                            <span class="PGLanguageButtonBar PGFormField-Actions-Translations" role="group" [attr.aria-label]="'pg-form-field.a11y.languages' | locTranslate">
                                @if (forceLanguage) {
                                    <button type="button" class="btn btn-sm btn-primary" disabled [attr.aria-pressed]="true">
                                        {{forceLanguage.split('_')[0].toUpperCase()}}
                                    </button>
                                }
                                @if (!forceLanguage) {
                                    @for (language of getAvailableLanguages(); track language) {
                                        <button type="button" class="btn btn-sm btn-{{getSelectedLanguage() == language ? 'primary' : 'secondary'}}"
                                            [attr.aria-pressed]="getSelectedLanguage() == language"
                                            (click)="setSelectedLanguage(language)">
                                            {{language.split('_')[0].toUpperCase()}}
                                        </button>
                                    }
                                }
                            </span>
                        }
                    </span>
                    @if (isFieldInvalid()) {
                        <div class="invalid-feedback d-block" [id]="getErrorMessageId()" role="alert">{{ getValidationErrorText() }}</div>
                    }
                </span>
            </label>
        </div>
    </div>
}
